const SESSION_PREFIX = "quiz_session_";
const ANSWERS_PREFIX = "quiz_answers_";

export const getStoredSession = (quizId) => {
  const sessionStr = localStorage.getItem(`${SESSION_PREFIX}${quizId}`);
  if (!sessionStr || sessionStr === "undefined") return null;
  try {
    return JSON.parse(sessionStr);
  } catch {
    return null;
  }
};

export const storeSession = (quizId, sessionId, startedAt, extra = {}) => {
  if (sessionId && quizId) {
    const sessionData =
      typeof extra === "object" && extra !== null
        ? { sessionId, startedAt, ...extra }
        : { sessionId, startedAt, enable_calculator: Boolean(extra) };

    localStorage.setItem(
      `${SESSION_PREFIX}${quizId}`,
      JSON.stringify(sessionData)
    );
  }
};

export const clearSession = (quizId, sessionId) => {
  localStorage.removeItem(`${SESSION_PREFIX}${quizId}`);
  localStorage.removeItem(`${ANSWERS_PREFIX}${quizId}`);
  if (sessionId) {
    localStorage.removeItem(`${ANSWERS_PREFIX}${quizId}_${sessionId}`);
  }
};

// --- Answer persistence ---

export const getStoredAnswers = (quizId, sessionId) => {
  const key = sessionId ? `${ANSWERS_PREFIX}${quizId}_${sessionId}` : `${ANSWERS_PREFIX}${quizId}`;
  const answersStr = localStorage.getItem(key);
  if (!answersStr || answersStr === "undefined") return null;
  try {
    return JSON.parse(answersStr);
  } catch {
    return null;
  }
};

export const storeAnswers = (quizId, sessionId, answers) => {
  if (quizId) {
    const key = sessionId ? `${ANSWERS_PREFIX}${quizId}_${sessionId}` : `${ANSWERS_PREFIX}${quizId}`;
    localStorage.setItem(key, JSON.stringify(answers));
  }
};

export const clearAnswers = (quizId, sessionId) => {
  localStorage.removeItem(`${ANSWERS_PREFIX}${quizId}`);
  if (sessionId) {
    localStorage.removeItem(`${ANSWERS_PREFIX}${quizId}_${sessionId}`);
  }
};
